import { Primary } from './Primary';
export const LegacyOrange = {
    ...Primary,
    colors: {
        ...Primary.colors,
        main: '#F5831E',
        mainDark: '#EE7111',
        mainLight: '#FFE6D1',
    },
    themeId: 'legacyOrange',
};
